import {HashLink} from 'react-router-hash-link'

import {APP_ROUTES} from '../../routes/routes'

const FooterProductsLinks = () => {
  const productsLinks = [
    {id: 'products-brands', label: 'Overview'},
    {id: 'products-our-products', label: 'Our products'},
    {id: 'products-countries', label: 'Geographical reach '}
  ]

  const links = productsLinks.map(({id, label}) => {
    return (
      <li className="footer-link" key={`footer-products-links-${id}`}>
        <HashLink to={`${APP_ROUTES.PRODUCTS}#${id}`}>{label}</HashLink>
      </li>
    )
  })

  return (
    <ul>
      <li className="footer-link heading">Products</li>
      {links}
    </ul>
  )
}

export default FooterProductsLinks
